import { render } from "./PendingWithdrawals.vue?vue&type=template&id=24a1b248&ts=true"
import script from "./PendingWithdrawals.vue?vue&type=script&lang=ts"
export * from "./PendingWithdrawals.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__